/** Wraps a MessagesPanel so the panel fills available height without making the page scroll. */
export default function MessagesShell({ children }) {
  return (
    <div className="flex flex-col h-[calc(100dvh-180px)] md:h-[calc(100vh-160px)]" data-testid="messages-shell">
      <div className="shrink-0 mb-4">
        <p className="aamg-label">Care team</p>
        <h1 className="text-3xl font-semibold mt-1" style={{ fontFamily: "Outfit" }}>Messages</h1>
      </div>
      <div className="flex-1 min-h-0">{children}</div>
    </div>
  );
}
